import { render } from "./CustomInputMask.vue?vue&type=template&id=d6520c4a&scoped=true"
import script from "./CustomInputMask.vue?vue&type=script&lang=js"
export * from "./CustomInputMask.vue?vue&type=script&lang=js"

import "./CustomInputMask.vue?vue&type=style&index=0&id=d6520c4a&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6520c4a"]])

export default __exports__